class CartWarranty extends HTMLElement {
  async connectedCallback() {
    const cartWarrantyJSONHTML = this.querySelector('[data-cart-warranty-json]');
    const cartWarrantyJSON = cartWarrantyJSONHTML ? JSON.parse(cartWarrantyJSONHTML.innerHTML) : null;

    this.cartTotalPrice = cartWarrantyJSON?.cart_total_price;
    this.cart = cartWarrantyJSON?.cart;
    this.protectionWarrantyProduct = cartWarrantyJSON?.protectionWarrantyProduct;
    this.unlimitedWarrantyProduct = cartWarrantyJSON?.unlimitedWarrantyProduct;

    this.isProtectionWarrantyInCart = !!this.findProductInCart(this.protectionWarrantyProduct.handle);
    this.isUnlimitedWarrantyInCart = !!this.findProductInCart(this.unlimitedWarrantyProduct.handle);

    this.actualProtectionWarranty = this.getProtectionWarrantyVariant();

    this.isUnlimitedWarrantyActive = await this.checkUnlimitedWarrantyActive();

    this.check();
    this.render();
    this.setupListeners();
  }

  render() {
    if (this.isUnlimitedWarrantyActive) {
      this.innerHTML = `
        <div>Unlimited Warranty - <span style="display: inline; color: var(--color-accent)">Included</span></div>
      `;
      return;
    }

    const base = `
      <label class="fake-checkbox-container">
        <input
          type="radio"
          value="base"
          name="cart-warranty"
          ${!this.isProtectionWarrantyInCart && !this.isUnlimitedWarrantyInCart ? 'checked' : ''}
        >
        <span class="fake-checkbox"></span>
  
        <span class="label">
          <span class="title">Base Warranty (included) - <strong>Free</strong></span>
  
          <span class="list">
            <span>30 Days</span>
            <span>Manufacturing defects</span>
            <span>Free shipping for warranty replacement</span>
          </span>
        </span>
      </label>
    `;

    const protection =
      this.protectionWarrantyProduct && this.actualProtectionWarranty
        ? `
      <label class="fake-checkbox-container">
        <input
          type="radio"
          value="protection"
          name="cart-warranty"
          ${this.isProtectionWarrantyInCart ? 'checked' : ''}
        >
        <span class="fake-checkbox"></span>

        <span class="label">
          <span class="title">Protection Plan - <strong>${formatMoney(this.actualProtectionWarranty?.price)}</strong></span>

          <span class="list">
            <span>1 Year</span>
            <span>Comprehensive solution for any tech Issue</span>
            <span>Power surges or electrical failures protection</span>
            <span>Repairs and Part Replacements</span>
            <span>Free shipping for replacements</span>
          </span>
        </span>
      </label>
    `
        : '';

    const unlimited = this.unlimitedWarrantyProduct.sellingPlan.id
      ? `
      <label class="fake-checkbox-container">
        <input
          type="radio"
          value="unlimited"
          name="cart-warranty"
          ${this.isUnlimitedWarrantyInCart ? 'checked' : ''}
        >
  
        <span class="fake-checkbox"></span>
  
        <span class="label">
          <span class="title">
            Unlimited Warranty - <strong>${formatMoney(this.unlimitedWarrantyProduct.sellingPlan.price)} / month</strong>
          </span>
  
          <span class="list">
            <span>Lifetime coverage (while subscribed)</span>
            <span>Comprehensive solution for any tech Issue</span>
            <span>Power surges or electrical failures protection</span>
            <span>Repairs and Part Replacements</span>
            <span>Free shipping for replacements</span>
          </span>
        </span>
      </label>
    `
      : '';

    this.innerHTML = `${base}${protection}${unlimited}`;
  }

  setupListeners() {
    const actionList = {
      base: this.onSelectBasePlan.bind(this),
      protection: this.onSelectProtectionPlan.bind(this),
      unlimited: this.onSelectUnlimitedPlan.bind(this),
    };

    this.querySelectorAll('input[type="radio"]').forEach(input => {
      input.addEventListener('change', e => actionList[e.target.value]?.());
    });
  }

  check() {
    if (this.isProtectionWarrantyInCart) {
      const selectedProtectionWarranty = this.findProductInCart(this.protectionWarrantyProduct.handle);
      let body = null;

      if (this.actualProtectionWarranty && selectedProtectionWarranty.id !== this.actualProtectionWarranty.id) {
        body = {
          updates: {
            [this.actualProtectionWarranty.id]: 1,
            [selectedProtectionWarranty.id]: 0,
          },
        };
      }

      if (selectedProtectionWarranty?.quantity > 1) {
        body = {
          updates: {
            [selectedProtectionWarranty.id]: 1,
          },
        };
      }

      if (body) {
        return Shopify.cart.update(body).then(this.refreshCart);
      }

      if (!this.actualProtectionWarranty) {
        return this.removeProduct(selectedProtectionWarranty.id).then(this.refreshCart);
      }
    }

    if (this.isUnlimitedWarrantyInCart) {
      const selectedUnlimitedWarranty = this.findProductInCart(this.unlimitedWarrantyProduct.handle);

      if (selectedUnlimitedWarranty.quantity > 1) {
        const body = {
          updates: {
            [selectedUnlimitedWarranty.id]: 1,
          },
        };
        return Shopify.cart.update(body).then(this.refreshCart);
      }

      if (!this.unlimitedWarrantyProduct.sellingPlan.id) {
        return this.removeProduct(selectedUnlimitedWarranty.id).then(this.refreshCart);
      }
    }

    if (this.isProtectionWarrantyInCart && this.isUnlimitedWarrantyInCart) {
      return this.setProtectionWarranty(false).then(this.refreshCart);
    }

    if (this.cartTotalPrice === 0) {
      if (this.isUnlimitedWarrantyInCart || this.isProtectionWarrantyInCart) {
        return this.promisesInSequence([
          this.setUnlimitedWarranty.bind(this, false),
          this.setProtectionWarranty.bind(this, false),
        ]).then(this.refreshCart);
      }

      this.remove();
    }
  }

  onSelectBasePlan() {
    this.promisesInSequence([
      this.setProtectionWarranty.bind(this, false),
      this.setUnlimitedWarranty.bind(this, false),
    ]).then(this.refreshCart);
  }

  onSelectProtectionPlan() {
    this.promisesInSequence([
      this.setUnlimitedWarranty.bind(this, false),
      this.setProtectionWarranty.bind(this, true),
    ]).then(this.refreshCart);
  }

  onSelectUnlimitedPlan() {
    this.promisesInSequence([
      this.setProtectionWarranty.bind(this, false),
      this.setUnlimitedWarranty.bind(this, true),
    ]).then(this.refreshCart);
  }

  setProtectionWarranty(value) {
    if ((value && this.isProtectionWarrantyInCart) || (!value && !this.isProtectionWarrantyInCart)) {
      return Promise.resolve();
    }

    if (value && !this.isProtectionWarrantyInCart) {
      return this.addProduct({id: this.actualProtectionWarranty?.id});
    } else {
      return this.removeProduct(
        this.cart?.items.find(item => item.handle === this.protectionWarrantyProduct.handle)?.id,
      );
    }
  }

  setUnlimitedWarranty(value) {
    if ((value && this.isUnlimitedWarrantyInCart) || (!value && !this.isUnlimitedWarrantyInCart)) {
      return Promise.resolve();
    }

    if (value) {
      return this.addProduct({
        id: this.unlimitedWarrantyProduct.variantId,
        sellingPlanId: this.unlimitedWarrantyProduct.sellingPlan.id,
      });
    } else {
      return this.removeProduct(this.unlimitedWarrantyProduct.variantId);
    }
  }

  addProduct({id, sellingPlanId}) {
    const body = {items: [{id, selling_plan: sellingPlanId}]};
    return Shopify.cart.add(body);
  }

  removeProduct(id) {
    const body = {updates: {[id]: 0}};
    return Shopify.cart.update(body);
  }

  findProductInCart(handle) {
    return this.cart?.items.find(item => item.handle === handle);
  }

  refreshCart() {
    Shopify.eventEmitter.emit('ald:cart:refresh');
  }

  getProtectionWarrantyVariant() {
    return this.protectionWarrantyRules.find(
      plan => this.cartTotalPrice > plan.min_order_price && this.cartTotalPrice < plan.max_order_price,
    );
  }

  async checkUnlimitedWarrantyActive() {
    const customerId = Shopify.customer.id;

    if (!this.unlimitedWarrantyProduct.sellingPlan.id || !customerId) return false;

    if (!Shopify.customer.subscriptions) {
      const response = await fetch(`https://ald-custom.digitaluniverse.app/api/subscriptions/${customerId}`, {
        signal: AbortSignal.timeout(3000),
      }).then(response => response.json());

      Shopify.customer.subscriptions = response.success ? response.subscriptions : [];
    }

    return Shopify.customer.subscriptions.some(
      subscription =>
        subscription.status === 'ACTIVE' &&
        subscription.lines.some(line => line.sellingPlanId === this.unlimitedWarrantyProduct.sellingPlan.id),
    );
  }

  promisesInSequence(promises) {
    return promises.reduce((previousPromise, currentPromise) => {
      return previousPromise.then(() => currentPromise());
    }, Promise.resolve());
  }

  get protectionWarrantyRules() {
    return [
      {
        price: 2999,
        min_order_price: 90,
        max_order_price: 100,
        id: 46908723527912,
      },
      {
        price: 3999,
        min_order_price: 10001,
        max_order_price: 19995,
        id: 46908723560680,
      },
      {
        price: 4999,
        min_order_price: 19996,
        max_order_price: 24995,
        id: 46908723593448,
      },
      {
        price: 5999,
        min_order_price: 24996,
        max_order_price: 29995,
        id: 46908723626216,
      },
      {
        price: 6999,
        min_order_price: 29996,
        max_order_price: 34995,
        id: 46908723658984,
      },
      {
        price: 7999,
        min_order_price: 34996,
        max_order_price: 39995,
        id: 46908723691752,
      },
      {
        price: 8999,
        min_order_price: 39996,
        max_order_price: 44995,
        id: 46908723724520,
      },
      {
        price: 9999,
        min_order_price: 44996,
        max_order_price: 49995,
        id: 46908723757288,
      },
      {
        price: 10999,
        min_order_price: 49996,
        max_order_price: 54995,
        id: 46908723790056,
      },
      {
        price: 11999,
        min_order_price: 54996,
        max_order_price: 59995,
        id: 46908723822824,
      },
      {
        price: 12999,
        min_order_price: 59996,
        max_order_price: 64995,
        id: 46908723855592,
      },
      {
        price: 13999,
        min_order_price: 64996,
        max_order_price: 69995,
        id: 46908723888360,
      },
      {
        price: 14999,
        min_order_price: 69996,
        max_order_price: 74995,
        id: 46908723921128,
      },
      {
        price: 15999,
        min_order_price: 74996,
        max_order_price: 79995,
        id: 46908723953896,
      },
      {
        price: 16999,
        min_order_price: 79996,
        max_order_price: 84995,
        id: 46908723986664,
      },
      {
        price: 17999,
        min_order_price: 84996,
        max_order_price: 89995,
        id: 46908724019432,
      },
      {
        price: 18999,
        min_order_price: 89996,
        max_order_price: 94995,
        id: 46908724052200,
      },
      {
        price: 19999,
        min_order_price: 94996,
        max_order_price: 99995,
        id: 46908724084968,
      },
      {
        price: 20999,
        min_order_price: 99996,
        max_order_price: 104995,
        id: 46908724117736,
      },
      {
        price: 21999,
        min_order_price: 104996,
        max_order_price: 109995,
        id: 46908724150504,
      },
      {
        price: 22999,
        min_order_price: 109996,
        max_order_price: 114995,
        id: 46908724183272,
      },
      {
        price: 23999,
        min_order_price: 114996,
        max_order_price: 119995,
        id: 46908724216040,
      },
      {
        price: 24999,
        min_order_price: 119996,
        max_order_price: 124995,
        id: 46908724248808,
      },
      {
        price: 25999,
        min_order_price: 124996,
        max_order_price: 129995,
        id: 46908724281576,
      },
      {
        price: 27999,
        min_order_price: 129996,
        max_order_price: 139995,
        id: 46908724314344,
      },
      {
        price: 29999,
        min_order_price: 139996,
        max_order_price: 149995,
        id: 46908724347112,
      },
      {
        price: 31999,
        min_order_price: 149996,
        max_order_price: 159995,
        id: 46908724379880,
      },
      {
        price: 33999,
        min_order_price: 159996,
        max_order_price: 169995,
        id: 46908724412648,
      },
      {
        price: 35999,
        min_order_price: 169996,
        max_order_price: 179995,
        id: 46908724445416,
      },
      {
        price: 37999,
        min_order_price: 179996,
        max_order_price: 189995,
        id: 46908724478184,
      },
      {
        price: 39999,
        min_order_price: 189996,
        max_order_price: 199995,
        id: 46908724510952,
      },
      {
        price: 41999,
        min_order_price: 199996,
        max_order_price: 209995,
        id: 46908724543720,
      },
      {
        price: 43999,
        min_order_price: 209996,
        max_order_price: 219995,
        id: 46908724576488,
      },
      {
        price: 45999,
        min_order_price: 219996,
        max_order_price: 229995,
        id: 46908724609256,
      },
      {
        price: 47999,
        min_order_price: 229996,
        max_order_price: 239995,
        id: 46908724642024,
      },
      {
        price: 49999,
        min_order_price: 239996,
        max_order_price: 249995,
        id: 46908724674792,
      },
      {
        price: 51999,
        min_order_price: 249996,
        max_order_price: 259995,
        id: 46908724707560,
      },
      {
        price: 53999,
        min_order_price: 259996,
        max_order_price: 269995,
        id: 46908724740328,
      },
      {
        price: 55999,
        min_order_price: 269996,
        max_order_price: 279995,
        id: 46908724773096,
      },
      {
        price: 57999,
        min_order_price: 279996,
        max_order_price: 289995,
        id: 46908724805864,
      },
      {
        price: 59999,
        min_order_price: 289996,
        max_order_price: 299995,
        id: 46908724838632,
      },
      {
        price: 63999,
        min_order_price: 299996,
        max_order_price: 319995,
        id: 46908724871400,
      },
      {
        price: 67999,
        min_order_price: 319996,
        max_order_price: 339995,
        id: 46908724904168,
      },
      {
        price: 69999,
        min_order_price: 339996,
        max_order_price: 349995,
        id: 46908724936936,
      },
      {
        price: 74999,
        min_order_price: 349996,
        max_order_price: 374995,
        id: 46908724969704,
      },
      {
        price: 79999,
        min_order_price: 374996,
        max_order_price: 399995,
        id: 46908725002472,
      },
      {
        price: 84999,
        min_order_price: 399996,
        max_order_price: 424995,
        id: 46908725035240,
      },
      {
        price: 86999,
        min_order_price: 424996,
        max_order_price: 434995,
        id: 46908725068008,
      },
      {
        price: 87999,
        min_order_price: 434996,
        max_order_price: 439995,
        id: 46908725100776,
      },
      {
        price: 89999,
        min_order_price: 439996,
        max_order_price: 449995,
        id: 46908725133544,
      },
      {
        price: 99999,
        min_order_price: 449996,
        max_order_price: 499995,
        id: 46908725166312,
      },
      {
        price: 109999,
        min_order_price: 499996,
        max_order_price: 549995,
        id: 46908725199080,
      },
      {
        price: 119999,
        min_order_price: 549996,
        max_order_price: 599995,
        id: 46908725231848,
      },
      {
        price: 129999,
        min_order_price: 599996,
        max_order_price: 649995,
        id: 46908725264616,
      },
      {
        price: 139999,
        min_order_price: 649996,
        max_order_price: 699995,
        id: 46908725297384,
      },
      {
        price: 149999,
        min_order_price: 699996,
        max_order_price: 749995,
        id: 46908725330152,
      },
      {
        price: 159999,
        min_order_price: 749996,
        max_order_price: 799995,
        id: 46908725362920,
      },
      {
        price: 169999,
        min_order_price: 799996,
        max_order_price: 849995,
        id: 46908725395688,
      },
      {
        price: 179999,
        min_order_price: 849996,
        max_order_price: 899995,
        id: 46908725428456,
      },
      {
        price: 189999,
        min_order_price: 899996,
        max_order_price: 949995,
        id: 46908725461224,
      },
    ];
  }
}

customElements.define('cart-warranty', CartWarranty);
